import { useState } from "react";
import { format } from "date-fns";
import { toast } from "sonner";
import { Phone, Mail, Users, Video, FileText, Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { SelectField, Empty, ConfirmDelete } from "./common";
import { TYPES_ECHANGE, fmtDate } from "../lib/constants";
import { useData } from "../context/DataContext";

const ICONS = { Appel: Phone, Email: Mail, "Réunion": Users, Visio: Video, "Document envoyé": FileText };

export const EchangesTimeline = ({ demandeId }) => {
  const { echanges, save, remove } = useData();
  const items = echanges.filter((e) => e.demande_id === demandeId).sort((a, b) => b.date.localeCompare(a.date));
  const now = () => format(new Date(), "yyyy-MM-dd'T'HH:mm");
  const [f, setF] = useState({ type: "Appel", date: now(), resume: "" });

  const add = async (e) => {
    e.preventDefault();
    if (!f.resume.trim()) return toast.error("Saisissez un résumé de l'échange");
    await save("echanges", { ...f, demande_id: demandeId });
    setF({ type: "Appel", date: now(), resume: "" });
    toast.success("Échange ajouté à l'historique");
  };

  return (
    <div data-testid="echanges-timeline">
      <form onSubmit={add} className="mb-8 space-y-3 rounded-lg border border-[var(--kc-line)] bg-[var(--kc-bg)] p-4">
        <div className="grid gap-3 sm:grid-cols-2">
          <SelectField testId="echange-type-select" value={f.type} onChange={(v) => setF({ ...f, type: v })} options={TYPES_ECHANGE} />
          <Input type="datetime-local" className="bg-white" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="echange-date-input" />
        </div>
        <Textarea rows={2} className="bg-white" value={f.resume} onChange={(e) => setF({ ...f, resume: e.target.value })} placeholder="Résumé de l'échange, décisions, points à suivre…" data-testid="echange-resume-input" />
        <div className="flex justify-end"><Button type="submit" size="sm" className="kc-btn-primary" data-testid="add-exchange-note-button">Ajouter à l'historique</Button></div>
      </form>
      {!items.length ? <Empty>Aucun échange enregistré pour ce client.</Empty> : (
        <ol className="relative ml-3 border-l border-[var(--kc-line)]">
          {items.map((e) => {
            const Icon = ICONS[e.type] || FileText;
            return (
              <li key={e.id} className="group relative mb-6 pl-8 last:mb-0" data-testid={`echange-item-${e.id}`}>
                <span className="absolute -left-[13px] top-0 grid h-6 w-6 place-items-center rounded-full border border-[var(--kc-line)] bg-white text-[var(--kc-navy)]"><Icon className="h-3 w-3" /></span>
                <div className="flex items-center gap-2 text-xs text-[var(--kc-muted)]">
                  <span className="font-semibold uppercase tracking-wider text-[var(--kc-gold-dark)]">{e.type}</span>
                  <span>·</span><span>{fmtDate(e.date, "d MMM yyyy · HH:mm")}</span>
                  <ConfirmDelete onConfirm={() => remove("echanges", e.id)} trigger={<button className="ml-auto opacity-0 transition-opacity group-hover:opacity-100" data-testid={`echange-delete-${e.id}`}><Trash2 className="h-3.5 w-3.5" /></button>} />
                </div>
                <p className="mt-1 text-sm leading-relaxed text-[var(--kc-ink)]">{e.resume}</p>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
};
